import { DataSet, Network } from "vis-network/standalone";
import { Options } from "vis-network/declarations/network/Network";
import { Requester } from "../common/requester";
import { Helper } from "../common/helper";
import { C } from "../common/component";
import { Loader } from "../common/loader";

interface GraphNode {
    Id: string;
    Label: string;
    Group: string;
    Image: string;
}

interface GraphEdge {
    From: string;
    To: string;
}

interface Graph {
    Nodes: GraphNode[];
    Edges: GraphEdge[];
}

export class PrincipalsGraph
{
    private readonly url: string;

    constructor(url: string)
    {
        this.url = url;
    }

    async appendTo(parent: JQuery)
    {
        const loader = Loader.startLocally(parent);
        try
        {
            const data: Graph = await Requester.get(this.url);
            const visNodes = data.Nodes.map(node => ({
                id: node.Id,
                label: node.Label,
                group: node.Group,
                ...(node.Image !== "" && { image: node.Image })
            }));

            const visEdges = data.Edges.map(edge => ({
                from: edge.From,
                to: edge.To
            }));

            const nodes = new DataSet(visNodes);
            const edges = new DataSet(visEdges);

            const container = C.div.css("width", "100%").css("height", Helper.mainHeight).appendTo(parent);
            const options: Options = {
                edges: {
                    arrows: {
                        to: {
                            enabled: true,
                            scaleFactor: 0.5,
                            type: "arrow",
                        },
                    },
                    color: {
                        color: "#666666",
                    },
                },
                physics: {
                    enabled: true,
                },
                groups: {
                    EmployeesGroup: {
                        shape: "box",
                        color: "#ffffff",
                    },
                    Employee: {
                        shape: "circularImage",
                        color: "#aa00ff",
                    }
                }
            };

            const network = new Network(container[0], { nodes, edges }, options);

            network.once("afterDrawing", () =>
            {
                loader.stop();
            });
        }
        catch (error)
        {
            loader.stop();
            console.error("Error rendering graph:", error);
        }
    }
}
